import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'now-modal-close',
    templateUrl: 'close.html',
    styleUrls: ['close.scss'],
    standalone: false
})

export class NowModalCloseButton implements OnInit {
    @Output() public onClose: EventEmitter<void> = new EventEmitter<void>();
    public imageOptions: MediaImageOptions;

    public ngOnInit(): void {
        this.imageOptions = {
            mobile: {
                base: 'client/v2/outline_2X.png',
                version: '1703180010',
                icon: false
            }
        };
    }

    public closeClick(): void {
        this.onClose.emit();
    }
}
